export default __webpack_public_path__ + "static/top_companies-2b0368600082529c3f43477b1f87f85c.svg";